const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/user/app/$appId/features-sms/tpl-config.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { TplConfigFilterParamSchema } from '@apps/main/features/user/pages/app/detail/feature-sms/tpl-config-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/user/app/$appId/features-sms/tpl-config')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: TplConfigFilterParamSchema
});